module.exports = __webpack_public_path__ + "img/8.4d29526.png";